<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label">{{ label }}</label>
    <div class="flex items-center gap-3" :class="{ 'mt-2': label }">
      <button
        type="button"
        role="switch"
        :aria-checked="modelValue"
        :disabled="disabled"
        class="relative inline-block h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        :class="modelValue ? 'bg-green-500' : 'bg-gray-300'"
        @click="toggle"
      >
        <span
          class="pointer-events-none absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out"
          :class="modelValue ? 'translate-x-5' : 'translate-x-0'"
        />
      </button>
      <span v-if="description" class="text-sm text-gray-700">{{ description }}</span>
    </div>
    <div v-if="errors.length" class="form-error">
      {{ errors[0] }}
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
</script>
